var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSocialMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM9.69561 11.5864C9.84227 11.7217 9.91717 11.9204 9.89729 12.1214V19.3589C9.94081 19.62 9.86039 19.8867 9.68067 20.0773L8 22.1637V22.4388H12.7656V22.1637L11.085 20.0773C10.9039 19.887 10.8185 19.622 10.8534 19.3589V13.0996L15.0364 22.4388H15.5219L19.1148 13.0996V20.5435C19.1148 20.7422 19.1148 20.7804 18.9879 20.9103L17.6956 22.1943V22.4694H23.9701V22.1943L22.7227 20.9409C22.6126 20.855 22.5579 20.7138 22.5808 20.574V11.3648C22.5579 11.225 22.6126 11.0838 22.7227 10.9979L24 9.74453V9.4694H19.578L16.4258 17.517L12.8403 9.4694H8.20168V9.74453L9.69561 11.5864Z",
    fill: "#383D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialMedium);
export default __webpack_public_path__ + "static/media/icon_social_medium.8eda76cd72b2e157284ffcb1d154ecdf.svg";
export { ForwardRef as ReactComponent };